import React from 'react';
import { Link } from 'react-scroll';
import { FaSearchPlus, FaChartLine, FaUserFriends } from 'react-icons/fa';

const About = () => {
  return (
    <section id="about" className="section bg-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-primary mb-6">SEO Agency in Kent</h2>
            <p className="text-lg mb-6">
              Amplified SEO is an independent SEO agency based in Rochester, Kent that works with 
              businesses across the UK.
            </p>
            <p className="mb-6">
              We have over 15 years of experience providing Search Engine Optimisation services for 
              websites across a wide range of industries including trade websites, automotive, entertainment, 
              music, finance and more.
            </p>
            <p className="mb-8">
              We understand that most businesses simply don't have the time or resources to optimise 
              their websites, but they also can't afford to pay some of the rates large SEO agencies are 
              charging, which is where we come in. We take pride and satisfaction in helping our customers 
              grow their businesses through affordable bespoke SEO services, where we work with you to 
              achieve the results you deserve.
            </p>
            <Link 
              to="contact" 
              smooth={true} 
              duration={500} 
              className="btn btn-accent"
            >
              Get In Touch
            </Link>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <FeatureCard 
              icon={<FaSearchPlus size={24} />}
              title="SEO Expertise"
              description="Our team has in-depth knowledge of the latest SEO techniques and algorithm updates."
            />
            <FeatureCard 
              icon={<FaChartLine size={24} />}
              title="Proven Results"
              description="We focus on measurable improvements in rankings, traffic, and conversions."
            />
            <FeatureCard 
              icon={<FaUserFriends size={24} />}
              title="Personal Service"
              description="As a small agency, we provide personalized attention to each client's needs."
            />
            <FeatureCard 
              icon={<div className="text-xl font-bold">15+</div>}
              title="Years of Experience"
              description="Over 15 years of experience working with businesses of all sizes."
            />
          </div>
        </div>
        
        <div className="mt-20">
          <div className="text-center mb-12">
            <h3 className="text-primary mb-4">Industries We've Helped</h3>
            <p className="max-w-3xl mx-auto">
              We've worked with businesses across many different sectors, helping them improve their 
              online visibility and grow their customer base.
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 text-center">
            <IndustryBadge name="Trade & Services" />
            <IndustryBadge name="Automotive" />
            <IndustryBadge name="Entertainment" />
            <IndustryBadge name="Music" />
            <IndustryBadge name="Finance" />
            <IndustryBadge name="Education" />
            <IndustryBadge name="Healthcare" />
            <IndustryBadge name="Retail" />
            <IndustryBadge name="Technology" />
            <IndustryBadge name="Real Estate" />
            <IndustryBadge name="Hospitality" />
            <IndustryBadge name="Legal" />
          </div>
        </div>
      </div>
    </section>
  );
};

const FeatureCard = ({ icon, title, description }) => {
  return (
    <div className="bg-primary/5 rounded-custom p-6 hover:shadow-custom transition-shadow">
      <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary text-white mb-4">
        {icon}
      </div>
      <h4 className="text-primary font-bold text-lg mb-2">{title}</h4>
      <p className="text-dark">{description}</p>
    </div>
  );
};

const IndustryBadge = ({ name }) => {
  return (
    <div className="bg-light rounded-custom py-3 px-4 shadow-sm hover:shadow-custom hover:bg-primary hover:text-white transition-all">
      {name}
    </div>
  );
};

export default About;
